import StaticContentPage from 'components/v2/contentful/staticContentPage/StaticContentPage';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import { TypePageFields } from 'types/contentful-types';
import { genericPageFetcher } from 'utils/contentful';
import useURLFragmentLink from 'utils/hooks/useURLFragmentLink';

// SEE: https://nextjs.org/docs/pages/building-your-application/data-fetching/incremental-static-regeneration
export const PublicSSRPage = ({ data }: { data: TypePageFields }) => {
  const { t } = useTranslation();

  useURLFragmentLink();

  return (
    <>
      <Head>
        <title>{`${data.title} — ${t('APP_TITLE')}`}</title>
        <meta
          name="description"
          content={data.metaContent ? `${data.metaContent}` : `${data.title}`}
        />
      </Head>
      <StaticContentPage data={data} />
    </>
  );
};

export const getServerSideProps = genericPageFetcher;
export default PublicSSRPage;
